"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyStagesRequest = void 0;
var MyStagesRequest = /** @class */ (function () {
    function MyStagesRequest() {
    }
    return MyStagesRequest;
}());
exports.MyStagesRequest = MyStagesRequest;
;
//# sourceMappingURL=myStages.request.js.map